import {PROVIDER_FLAGS} from '@Constants/index.constants.js';

export const ViewExpiredState = {
	url: '/expired/:customerToken/:serviceProviderId/:consultationId',
	title: 'Expired',
	params: {customerToken: null, serviceProviderId: null, consultationId: null},
	templateProvider: [
		'providerFlags',
		providerFlags =>
			providerFlags?.[PROVIDER_FLAGS.PRESENTATION_V2]
				? '<view-expired-v2></view-expired-v2>'
				: '<view-expired></view-expired>',
	],
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		const RoutesSvc = $transition$.injector().get('RoutesResolveSvc');
		return (
			RoutesSvc.getPresentationFlags({trans: $transition$})
				// a failed lookup imports the production page
				.catch(() => ({}))
				.then(flags =>
					flags?.[PROVIDER_FLAGS.PRESENTATION_V2]
						? import(
								/* webpackChunkName: "viewExpiredV2Mod" */
								'@Containers/view-expired-page/view-expired-v2.cmp.js'
							)
						: import(
								/* webpackChunkName: "viewExpiredPageMod" */
								'@Containers/view-expired-page/view-expired.cmp.js'
							)
				)
				.then(res => $ocLazyLoad.load({name: res.default}))
				.catch(err => $log.error(err))
		);
	},
	resolve: [
		{
			token: 'providerFlags',
			policy: {when: 'LAZY'},
			deps: ['RoutesResolveSvc', '$transition$', '$log'],
			// this rejection is swallowed rather than allowed to fail the transition. This state
			// is one of the places customers land when their consultation is unreachable,
			// an empty payload renders the v1 page
			resolveFn: (RoutesSvc, trans, $log) =>
				RoutesSvc.getPresentationFlags({trans}).catch(err => {
					$log.error('view.expired provider flags failed, falling back to v1:', err);
					return {};
				}),
		},
	],
};
